// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"a3da249b","620":"e89d1026","906":"90176470"}[chunkId] + ".chunk.js";
};